export const rgyellow = {
    FOOTBALL_SUPER_SERIES: 'Football Super Series',
    FREE_TO_PLAY: 'Free to Play',
    ONE_TWO_FREE: '1-2-Free',
    FANZONE: 'Fanzone',
    PROMOTIONS: 'Promotions',
    RACING_SUPER_SERIES: 'Racing Super Series',
    FIVE_A_SIDE: '5-a-side',
    HOME_URL: '/',
    ERROR_MSG: 'User Permission Denied',
    BET_BUNDLES: 'Bet Bundles',
};
